import { JobBookingStatus } from '@src/constants/JobBookingStatus';
import useApi, { ApiOptions } from '../base/useApi';

interface Params {
  availabilityId: string;
  jobId: string;
  accept: boolean;
}

interface Result {
  status?: JobBookingStatus;
}

const options: ApiOptions = {
  method: 'post',
  urlPath: '/job/decision',
  baseUrl: process.env.REACT_APP_API_URL!,
  lazy: false,
  useGCKey: true,
};

export const useSaveJobDecisionLazy = (params?: Params) => {
  options.lazy = true;
  return useApi<Params, Result>(options, params);
};

export default useSaveJobDecisionLazy;
